import styled from '@emotion/styled';
import { Accordion, Stack, tokens } from '@hotjar/hotsauce';
import type { WizardSection, WizardSectionKey } from '../../../../../domain/common/Wizard/Wizard';

const StepContainer = styled(Stack)``;

const MainSection = styled(Stack)<{ hasSideSection: boolean }>`
  min-width: fit-content;
  padding: ${tokens.spacer.x2} ${tokens.spacer.x6};
  ${({ hasSideSection }) => (hasSideSection ? `` : `width: 100%;`)}
`;

const SideSection = styled.div`
  background-color: ${tokens.color.neutral_100};
  width: 100%;
  margin: -${tokens.spacer.x1} -${tokens.spacer.x3} -${tokens.spacer.x2} 0;
  padding: ${tokens.spacer.x3} ${tokens.spacer.x2};
`;

const MainSectionFooter = styled.div`
  margin-top: ${tokens.spacer.x3};
`;

const SectionSummary = styled.div`
  font-weight: normal;
`;

export interface AccordionSectionProps {
  footerContent?: JSX.Element;
  section: WizardSection<WizardSectionKey>;
  customIndex?: number;
}

export const AccordionSection = ({
  customIndex,
  footerContent,
  section,
}: AccordionSectionProps): JSX.Element => {
  return (
    <Accordion.Section
      customIndex={customIndex}
      title={
        <Stack spacing="x0" id={`section-${section.key}`}>
          <div>
            {section.title}
            {section.status === 1 ? ':' : ''}
          </div>
          {section.status === 1 ? <SectionSummary>{section.summary}</SectionSummary> : null}
        </Stack>
      }
      status={section.status}
    >
      <StepContainer>
        {section.mainContent && (
          <MainSection direction="column" hasSideSection={Boolean(section.sideContent)}>
            {section.mainContent}
            {footerContent !== undefined && <MainSectionFooter>{footerContent}</MainSectionFooter>}
          </MainSection>
        )}
        {section.sideContent && (
          <SideSection data-testid="sideContent">{section.sideContent}</SideSection>
        )}
      </StepContainer>
    </Accordion.Section>
  );
};
